import { BetQLSportItem } from "src/common-services";
import pluralize from "pluralize";
import React from "react";
import { UpgradeToView } from "../../RowComponents";
interface ConsensusCellOptions {
  awayTeam: any;
  homeTeam: any;
  game: any;
  filterKey: string;
  periodFilter: string;
  index: number;
  currentSportObj: BetQLSportItem;
  showDraw: boolean;
  hasAccess: boolean;
}

export const getConsensusCell = ({
  awayTeam,
  homeTeam,
  filterKey,
  game,
  index,
  currentSportObj,
  showDraw,
  hasAccess,
}: ConsensusCellOptions) => {
  const { awayCount, homeCount, drawCount, favoredTeam } = game.trendsPick;

  const isTotalBet = filterKey.includes("total");

  const classNameForTrendCount = "games-table-column__selected-count";
  const classNameForGameColumn = isTotalBet ? "team-info-container" : "consensus-team-container";
  const classNameForAwayDisplay = favoredTeam === "away" ? `${classNameForTrendCount}--highlighted` : "";
  const classNameForHomeDisplay = favoredTeam === "home" ? `${classNameForTrendCount}--highlighted` : "";
  const classNameForDrawDisplay = favoredTeam === "draw" ? `${classNameForTrendCount}--highlighted` : "";

  const usePreferredName = currentSportObj.isCollege ? "fullName" : "lastName";

  const classname = "games-table-column__consensus-cell";
  const classNameForDrawColumn = showDraw ? `${classname}--draw` : "";

  if (!hasAccess) {
    return (
      <UpgradeToView
        key={index}
        className={`${classname} ${classname}--paywall ${classNameForDrawColumn} `}
        showText={true}
        isSharpStat={false}
        trackingProps={{
          screen: "FeedView",
          page: "Games Table",
          source: "Trend Cell",
          sport: currentSportObj.key,
          gameId: game.id,
          awayTeam: game.awayTeam.fullName,
          homeTeam: game.homeTeam.fullName,
        }}
      />
    );
  }
  return (
    <div key={index} className={`games-table-column__consensus-cell ${classNameForDrawColumn}`}>
      <div className={`games-table-column__${classNameForGameColumn}`}>
        {!isTotalBet ? (
          <p className="games-table-column__team-name" style={{ textAlign: "right" }}>
            {awayTeam[usePreferredName]}
          </p>
        ) : null}
        <p className={`${classNameForTrendCount} ${classNameForAwayDisplay}`}>{pluralize("Trend", awayCount, true)}</p>
      </div>

      <div className={`games-table-column__${classNameForGameColumn}`}>
        {!isTotalBet ? (
          <p className="games-table-column__team-name" style={{ textAlign: "right" }}>
            {homeTeam[usePreferredName]}
          </p>
        ) : null}
        <p className={`${classNameForTrendCount} ${classNameForHomeDisplay}`}>{pluralize("Trend", homeCount, true)}</p>
      </div>

      {showDraw ? (
        <div className={`games-table-column__${classNameForGameColumn}`}>
          {!isTotalBet ? (
            <p className="games-table-column__team-name" style={{ textAlign: "right" }}>
              Draw
            </p>
          ) : null}
          <p className={`${classNameForTrendCount} ${classNameForDrawDisplay}`}>
            {pluralize("Trend", drawCount, true)}
          </p>
        </div>
      ) : null}
    </div>
  );
};
